import { render } from "./ModuleFacet.vue?vue&type=template&id=78d86df2&scoped=true"
import script from "./ModuleFacet.vue?vue&type=script&lang=js"
export * from "./ModuleFacet.vue?vue&type=script&lang=js"

import "./ModuleFacet.vue?vue&type=style&index=0&id=78d86df2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d86df2"]])

export default __exports__